import { render, staticRenderFns } from "./DaftarKontrakPerusahaan.vue?vue&type=template&id=75a668ea&scoped=true"
import script from "./DaftarKontrakPerusahaan.vue?vue&type=script&lang=js"
export * from "./DaftarKontrakPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./DaftarKontrakPerusahaan.vue?vue&type=style&index=0&id=75a668ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a668ea",
  null
  
)

export default component.exports